<template>
  <v-pagination
    v-model="page"
    :length="pagesQuantity"
    :total-visible="totalVisible"
    :color="color"
    circle
    @input="onPageChanged"
  />
</template>

<script setup lang="ts">
import { computed, watch, ref } from 'vue'
import smoothScrollToSelector from 'src/utils/smoothScrollToSelector'

const props = withDefaults(defineProps<{
  currentPage?: number,
  pagesLength: number,
  mobile: boolean,
  scrollToSelector?: string,
  color?: string,
}>(), {
  currentPage: 1,
  scrollToSelector: '',
  color: 'primary',
})

const totalVisible = props.mobile ? 5 : 7
const page = ref(props.currentPage)

watch(() => props.currentPage, newValue => {
  page.value = newValue
})

const pagesQuantity = computed(() => {
  const displayQuantityButtons = page.value - 1 + totalVisible

  if (props.pagesLength > 7 && displayQuantityButtons < props.pagesLength) {
    return displayQuantityButtons
  }

  return props.pagesLength
})

type Emits = {
  (_event: 'input', _value: { pageNumber: number }): void
}

const emit = defineEmits<Emits>()

function onPageChanged(pageNumber: number) {
  setTimeout(() => {
    smoothScrollToSelector(props.scrollToSelector)
  })

  emit('input', { pageNumber })
}
</script>
